export const BUILD_VERSION = '1788205186';
